import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/activity/custom/list',
        method: 'post',
        data: data
    })
}

export function getInfo(data) {
    return request({
        url: '/backend/activity/custom/info',
        method: 'post',
        data: data
    })
}

export function savePageElementInfo(data) {
    return request({
        url: '/backend/activity/custom/savePageElementInfo',
        method: 'post',
        data: data
    })
}

export function savePageIdInfo(data) {
    return request({
        url: '/backend/activity/custom/savePageIdInfo',
        method: 'post',
        data: data
    })
}

export function createActivityInfo(data) {
    return request({
        url: '/backend/activity/custom/createActivityInfo',
        method: 'post',
        data: data
    })
}

export function updateActivityInfo(data) {
    return request({
        url: '/backend/activity/custom/updateActivityInfo',
        method: 'post',
        data: data
    })
}

export function updateOnline(data) {
    return request({
        url: '/backend/activity/custom/updateOnline',
        method: 'post',
        data: data
    })
}

export function deleteActivityInfo(data) {
    return request({
        url: '/backend/activity/custom/deleteActivityInfo',
        method: 'post',
        data: data
    })
}